import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
import Vehicle from './models/Vehicle'
// const querystring = require('querystring');
export default class ManageVehicle extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		let parms = "";
		// JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
//         console.log("parms => " + parms);
		this.state={
			id : JSON.parse(parms).id,
			vehicle : Vehicle,
			identityPrincipal : ""
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
		
		
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({vehicle : {...this.state.vehicle, [target.id] : target.value} });
	   
		console.log(this.state);
	  }
	handleSubmit(event) {
		event.preventDefault();
		console.log('handling submit');  
	
	  	var url = `${global.config.dataServicesUrl}/gazelle/Vehicles`;
				
		axios.put(url, this.state.vehicle).then(response2 => {
			console.log(response2.status +":"+response2.data);
			if (response2.status === 200 )
			{
				this.message = "Success";
			}
			else
			{
				 this.message = "Failed";
			}        
			console.log(this.message);
		  	}).catch(err => {
				console.log("error - " + err);
		  	});
		console.log("message info - " + this.message); 
	 };
	 handleClear(){
	 	let zoneObject = Vehicle;
		this.setState({vehicle : zoneObject})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad(){		
		var queryUrl = `${global.config.dataServicesUrl}/gazelle/Vehicles/id/${this.state.id}`;
		axios.get(queryUrl)
		 	.then(response => {
			this.setState({vehicle : response.data[0]});	
			});
	}

	handleDelete(){		
		var queryUrl = `${global.config.dataServicesUrl}/gazelle/Vehicles/id/${this.state.id}`;
		axios.delete(queryUrl)
		 	.then(response => {
			});
// 		this.setState({vehicle : Vehicle});	
		window.location.href = '/vlm-home';
	}	
	render(){
    return (
        	<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Manage Vehicle</h4>
		<hr />

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Name</label>
		<input id="name" class="form-control input-medium col-sm-8" value={this.state.vehicle.name} onChange ={this.handleChange}/>
		</div>

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Description</label>
		<input id="description" class="form-control input-medium col-sm-8" value={this.state.vehicle.description} onChange ={this.handleChange} /> 
		</div>

		<div class="form-group row">
			<label class="ContentTitle col-sm-2">Notes</label>
			<textarea id="notes" class="form-control input-medium col-sm-8" value={this.state.vehicle.notes} onChange ={this.handleChange}>				
			</textarea>
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">VIN</label>
		<input id="vin" class="form-control input-medium col-sm-8" value={this.state.vehicle.vin} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Manufacturer</label>
		<input id="manufacturer" class="form-control input-medium col-sm-8" value={this.state.vehicle.manufacturer} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Model</label>
		<input id="model" class="form-control input-medium col-sm-8" value={this.state.vehicle.model} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Year</label>
		<input id="year" class="form-control input-medium col-sm-8" value={this.state.vehicle.year} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Color</label>
		<input id="color" class="form-control input-medium col-sm-8" value={this.state.vehicle.color} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Nickname</label>
		<input id="nickname" class="form-control input-medium col-sm-8" value={this.state.vehicle.nickname} onChange ={this.handleChange} /> 
		</div>

		<hr/>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Created By</label>
		<input id="createUserName" class="form-control input-medium col-sm-2" value={this.state.vehicle.createUser} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="createDate" class="form-control input-medium col-sm-2" value={String(this.state.vehicle.createDate).substring(0,10)} />
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Last Updated By</label>
		<input id="lastUpdateUserName" class="form-control input-medium col-sm-2" value={this.state.vehicle.lastUpdateUser} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="lastUpdateDate" class="form-control input-medium col-sm-2" value={String(this.state.vehicle.lastUpdateDate).substring(0,10)} />
		</div>
		<hr />					
			<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
			<button class="btn btn-success" value="Save" onClick ={this.handleSubmit}>Save</button>&nbsp;
			<button class="btn btn-danger" value="Create" onClick ={this.handleDelete}>Delete</button>&nbsp;
		</div>		
		</form>
						</div>		
	            	</div>	
            	</div>            
			</div>
		</div>
	);
}
}